<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import router from "@/router";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { setHaptic } from "@/tools/setTelegramHaptick";
import { setBackButton, hideBackButton, setBottomButton, hideBottomButton } from '@/tools/setTelegramButtons';
import { addOrder } from '@/composables/orderWorkerk';
import { createPopupManager } from '@/tools/setTelegramPopUp'
import CartItem from '@/components/mobile/telegram/cart_components/CartItem.vue';
import { ProductWithPackaging } from "@/models/product";
import Point from "@/models/point";

const point_uuid = ref();
const point_id = ref();
const points = ref<Point[]>([]);
const pointName = ref<string>("");
const store = useStore();
const editRef = ref(false);
const inputRefComment = ref<HTMLInputElement | null>(null);
let mainButtonListener: (() => void) | null = null;
const popupManager = createPopupManager();

const handleMainButton = async () => {
  setHaptic();
  if (editRef.value === true) {
    editRef.value = !editRef.value;
    setBottomButton('Заказать', '31B545', 'FFFFFF', handleMainButton)
    return;
  }
  if (cartItems.value.length !== 0){
    await createOrder();
  }
  else {
    router.go(-1)
  }
};

onMounted(async() => {
  setBackButton();
  point_uuid.value = useRoute().query.point_uuid;
  point_id.value = Number(useRoute().query.point_id);
  console.log('store=', store)
  points.value = store.getters.getAllPoints;
  const targetPoint = points.value.find((point) => point.id === point_id.value);
  if (targetPoint) {
    pointName.value = targetPoint.name
  } else {
    pointName.value = "notFoundPointName"
  }
  console.log('pointName.value=', pointName.value)
  mainButtonListener = handleMainButton;
  if(cartItems.value.length > 0) {
    setBottomButton('Заказать', '31B545', 'FFFFFF', handleMainButton)
  }
  else {
    setBottomButton('На главную', '31B545', 'FFFFFF', handleMainButton)
  }
})

onUnmounted(() => {
  hideBackButton();
  hideBottomButton();
});

//Функция редактирования корзины
const editCart = () => {
  setHaptic();
  editRef.value = !editRef.value;
  setBottomButton('Подтвердить', '31B545', 'FFFFFF', handleMainButton)
}

function noneClick() {
  console.log('click')
}

//Создать заказ
async function createOrder() {

  setBottomButton('Ждём подтверждения', '31B545', 'FFFFFF', null, false, true);

  const data = await addOrder(point_id.value, inputRefComment.value!.innerText, formattedCartItems.value)
  if (data) {
    popupManager.openPopup(`Ваш заказ успешно добавлен`,
      (buttonId) => {
        console.log("Нажата кнопка:", buttonId);
      },
    );
    router.push('/');
    store.dispatch('clearPointCart', point_id.value);
  }
}

//Логика рендера товаров корзины
const cartItems = computed(() => {
  return store.getters.getCartItemsByPoint(point_id.value);
}) 

const isCatrIsEmpty = ref<boolean>(true)

watch(() => cartItems.value, (newVal) => {
  console.log('newVal=', newVal.length)
  if (newVal.length !== 0) {
    isCatrIsEmpty.value = false;
  } 
  if (newVal.length === 0) {
    isCatrIsEmpty.value = true;
    editRef.value = false;
    setBottomButton('К товарам', '31B545', 'FFFFFF', handleMainButton)
  } 
}, {immediate:true})

const formattedCartItems = computed<{ name: string; quantity: number, containerId: string }[]>(() =>
  cartItems.value.map((item: ProductWithPackaging) => ({
    name: item.name as string,
    quantity: item.quantity as number,
    containerId: item.packaging.id as string
  }))
);

</script>

<template>
  <div class="cart-wrapper">
    <div class="cart-head">
      <p class="cart-head__label">Корзина</p>
      <div class="cart-header">
        <p class="name-cart">{{ pointName }}</p>
      </div>
    </div>
    <div v-if="isCatrIsEmpty" class="btn-toshop">
      КОРЗИНА ПУСТА
    </div>
    <div class="input-wrapper" v-if="!isCatrIsEmpty">
      <div
        ref="inputRefComment"
        class="text"
        contenteditable="true"
        role="textbox"
        aria-multiline="true"
        placeholder="Добавить комментарий..."
      ></div>
    </div>
    <div v-if="!isCatrIsEmpty" class="cart-items">
      <CartItem v-for="(item, id) in cartItems"
        :item="item"
        :point_id="point_id"
        :editRef="editRef"
      />
      <p v-if="!isCatrIsEmpty && !editRef" class="edit-cart" :style="{ color: editRef ? 'var(--orange-color)' : 'var(--green-color)' }" @click="editCart()">{{ editRef ? 'Подтвердить' : 'Редактировать' }}</p>
    </div>
  </div>
</template>

<style scoped>

.cart-head {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  gap: 15px;
  box-sizing: border-box;
  padding: 20px;
  background-color: white;
  border-radius: var(--border-radius);
  position: sticky;
  top: 0px;
  z-index: 1;
  box-shadow: var(--drop-shadow-item);
}

.btn-toshop{
  margin-top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 20px;
  color: black;
}

.text {
  background-color: inherit;
  font-size: 16px;
  padding: 12px 10px;
  font-family: inherit;
  margin: 0;
  border: none;
  outline: none;
  width: 100%;
  min-height: 50px;
  overflow-y: auto;
  word-wrap: break-word;
  white-space: pre-wrap;
  line-height: 1.5;
  box-sizing: border-box;
  text-align: start;
  color: #525252;
}

.text:empty:before {
  content: attr(placeholder);
  color: #B9B9B9;
  pointer-events: none;
}

.text:focus {
  outline: none;
}

.input-wrapper {
  margin-top: 5px;
  width: 100%;
  min-height: 50px;
  background-color: white;
  border-radius: var(--border-radius);
  display: flex;
  padding: 0 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: var(--drop-shadow-item);
}

.cart-items{
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  width: 100%;
  /* gap: 15px; */
  box-sizing: border-box;
  background-color: white;
  border-radius: var(--border-radius);
  padding: 0 10px;
  box-shadow: var(--drop-shadow-item);
  margin-bottom: 10px;
}

.edit-cart{
  font-size: 15px;
  color: var(--green-color);
  font-weight: 600;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: white;
  border-radius: var(--border-radius);
  margin-top: 1px;
}

.name-cart{
  font-size: 18px;
  color: black;
  font-weight: 600;
}

.cart-head__label {
  font-size: 16px;
  color: #B9B9B9;
  font-weight: 600;
}

.cart-header{
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.cart-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}
</style>